import { Component, Input, OnInit, SimpleChanges, OnChanges } from '@angular/core';
import { Transaction, TransactionQuery, TransactionService, TransactionType } from '@fgb/core';
import moment from 'moment/moment';
import { switchMap, map, tap } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { ViewportScroller } from '@angular/common';
interface GroupedTransactions {
  [day: string]: Transaction[];
}
@Component({
  selector: 'fgbcl-card-linked-transactions-list',
  templateUrl: './card-linked-transactions-list.component.html',
  styleUrls: ['./card-linked-transactions-list.component.scss'],
})
export class CardLinkedTransactionsListComponent implements OnInit, OnChanges {
  @Input() transactionStartDate: Date;
  @Input() transactionEndDate: Date;

  @Input() memberId: string;

  @Input() dateFormat: string = 'MMM DD, YYYY';
  @Input() minDate?: Date = new Date('Aug 01,2022');

  transactions$: Observable<GroupedTransactions>;
  transactionType = TransactionType.cardlink;
  keys = Object.keys;
  loading: boolean = false;
  hasTransactions = false;
  constructor(
    private transactionService: TransactionService,
    private transactionQuery: TransactionQuery,
    private scroller: ViewportScroller
  ) {}

  ngOnInit(): void {
    this.transactionEndDate = this.transactionEndDate || new Date();
    this.transactionStartDate = new Date();
    this.transactionStartDate.setDate(new Date(this.transactionStartDate).getDate() - 1);
    this.getTransactions();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.startDate || changes.endDate || changes.transactionType) {
      if (changes.memberId) {
        this.getTransactions();
      }
    }
  }
  /**
 Fatch Transaction according to date range
   */
  getTransactions() {
    const transactionEndDate = new Date(this.transactionEndDate);
    this.transactionStartDate.setHours(0, 0, 0);
    transactionEndDate.setHours(23, 59, 59);
    this.loading = true;
    this.transactions$ = this.transactionService
      .fetchTransactions(this.transactionStartDate, transactionEndDate, this.memberId, this.transactionType)
      .pipe(
        switchMap(() =>
          this.transactionQuery.selectTransactions(this.transactionStartDate, transactionEndDate, this.transactionType)
        ),
        map((t: Transaction[]) => {
          return this._groupByTransactionDate(t);
        }),
        tap((groupedTransactions) => {
          this.hasTransactions = Object.keys(groupedTransactions).length > 0;
          this.loading = false;
        })
      );
    this.scroller.scrollToAnchor('cardTransactionList');
  }

  private _groupByTransactionDate(transactions: Transaction[]): GroupedTransactions {
    // sort by date descending
    const sorted = transactions.sort(
      (a, b) => new Date(b.TransactionDateUTC).getTime() - new Date(a.TransactionDateUTC).getTime()
    );

    // group into object with stringified dates as keys
    return sorted.reduce<GroupedTransactions>((grouped, tx) => {
      const txDate = moment(tx.TransactionDateUTC).format(this.dateFormat);
      if (grouped[txDate]) {
        grouped[txDate].push(tx);
      } else {
        grouped[txDate] = [tx];
      }
      return grouped;
    }, {});
  }

  keepOrder = (a: any, b: any) => a.key;
}
